import { Stack, Typography } from '@mui/material';

import { ApiWorkflowDialog, DialogMessageBox } from '@verantos-dev/shared-components';

import { useDeleteCohortModal } from '../../hooks/useDeleteCohortModal';
import { useDeleteCohortModalStrings } from '../../hooks/useDeleteCohortModalStrings';

export const DeleteCohortModal = () => {
  const {
    isDisableDeleteStatus,
    onClose,
    onSubmit,
    isSubmitting,
    isInitialLoading,
    deleteCohortError,
    saveButtonColor,
    isValidForSubmit,
    cohort,
  } = useDeleteCohortModal();
  const { contentMessages, dialogMessages } = useDeleteCohortModalStrings(cohort);

  return (
    <ApiWorkflowDialog
      id="deleteCohortModal"
      title={contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      saveButtonColor={saveButtonColor}
      submittingError={deleteCohortError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      hideDisplayButtonsOnSuccess
    >
      <DialogMessageBox
        id="delete-cohort-message-box"
        title={contentMessages.confirmTitle}
        type="error"
        variant="outlined"
        renderSubmitted={
          !isDisableDeleteStatus ? (
            <Stack gap={4}>
              <Typography color="error">{contentMessages.actionUndone}</Typography>
              <Typography>{contentMessages.description}</Typography>
            </Stack>
          ) : (
            <Typography>{contentMessages.disableDeleteStatus}</Typography>
          )
        }
      />
    </ApiWorkflowDialog>
  );
};
